import { createFileRoute } from "@tanstack/react-router";
import { BlankScreen } from "../-blank-screen";
import { requireSurface } from "../-guards";

// /staff/applications — sidebar destination, no feature yet. Guarded on the same surface as the rest of
// the staff screens so nav visibility and route access can't disagree.
export const Route = createFileRoute("/staff/applications")({
  beforeLoad: ({ context, location }) =>
    requireSurface(
      context.queryClient,
      "round_configuration",
      location.pathname
    ),
  staticData: { breadcrumb: ["nav.applications"] },
  component: () => <BlankScreen titleKey="nav.applications" />,
});
